import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

//调拨统计
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}